import { render } from "./PartInfoDialog.vue?vue&type=template&id=5fa35df8&scoped=true"
import script from "./PartInfoDialog.vue?vue&type=script&lang=js"
export * from "./PartInfoDialog.vue?vue&type=script&lang=js"

import "./PartInfoDialog.vue?vue&type=style&index=0&id=5fa35df8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa35df8"]])

export default __exports__